import React, { useState } from 'react';
import { Box, Button, Heading, Layer, TextInput } from 'grommet';
import { Close } from 'grommet-icons';
import PropTypes from 'prop-types';
import { API } from '@enrich/shared-lib';
import { useNavigate } from 'react-router-dom';
// import QueryString from 'qs';

export const ContactListButton = ({ options }) => {
    const [showModal, setShowModal] = useState(false);

    return (
        <Box>
            <Button
                secondary
                disabled={!options}
                size="large"
                label="Create list from results"
                onClick={() => setShowModal(true)}
            />
            {showModal && (
                <ContactListModal
                    options={options}
                    setShowModal={setShowModal}
                />
            )}
        </Box>
    );
};

const ContactListModal = ({ options, setShowModal }) => {
    const [listName, setListName] = useState();
    const [buttonBusy, setButtonBusy] = useState();
    const navigate = useNavigate();

    const createContactList = async () => {
        const filteredOptions = Object.entries(options).reduce(
            (filteredResults, [key, value]) => {
                const isEmptyArray = Array.isArray(value) && value.length == 0;
                if (!isEmptyArray && value) {
                    filteredResults[key] = value;
                }
                return filteredResults;
            },
            {},
        );

        try {
            setButtonBusy(true);
            const createListResponse = await API.post('/api/contact-lists', {
                data: {
                    name: listName,
                    searchFilters: filteredOptions,
                },
            });
            setShowModal(false);
            const newListId = createListResponse.data.data.id;
            navigate(`/lists/${newListId}`);
        } catch (error) {
            setButtonBusy(false);
            console.log(error);
        }
    };

    return (
        <Layer
            onClickOutside={() => setShowModal(false)}
            onEsc={() => setShowModal(false)}
            position="center">
            <Box
                background="white"
                pad="medium"
                round="6px"
                border={{ color: 'enrich-green-light', size: '3px' }}
                alignSelf="center"
                gap="30px">
                <Box direction="row" gap="20px" justify="between">
                    <Heading level="3" margin={{ vertical: 'none' }}>
                        New list name
                    </Heading>
                    <Box align="end">
                        <Close
                            onClick={() => {
                                setShowModal(false);
                            }}
                            cursor="pointer"
                        />
                    </Box>
                </Box>
                <Box>
                    <TextInput
                        onChange={(event) => setListName(event.target.value)}
                    />
                </Box>
                <Box>
                    <Button
                        primary
                        busy={buttonBusy}
                        disabled={!listName}
                        label="Create list"
                        style={{ width: '220px', height: '50px' }}
                        alignSelf="center"
                        onClick={createContactList}
                    />
                </Box>
            </Box>
        </Layer>
    );
};

ContactListButton.propTypes = {
    options: PropTypes.object,
};

ContactListModal.propTypes = {
    options: PropTypes.object,
    setShowModal: PropTypes.func,
};
